import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import addMetaDescription from '@/assets/js/addMetaDescription'

import Home from '@/views/Home.vue'
import Page404 from '@/views/404.vue'
import Health from '@/views/Health.vue'
import IE from '@/views/IE.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Królewskie',
      description: store.state.mainMetaDescription
    }
  },
  {
    path: '/404/',
    name: '404',
    component: Page404,
    meta: {
      title: 'Królewskie - Nie ma takiej strony'
    }
  },
  {
    path: '/ie/',
    name: 'ie',
    component: IE
  },
  {
    path: '/zdrowie/',
    name: 'health',
    component: Health
  },
  {
    path: '/:section/',
    name: 'section',
    component: Home
  },
  {
    path: '*',
    redirect: '/404/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // IE middleware
  const ua = window.navigator.userAgent
  const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
  const isOnIEUrl = ['/ie', '/ie/'].includes(to.path)

  if (isIE && !isOnIEUrl) {
    next('/ie/')
    return
  } else if (!isIE && isOnIEUrl) {
    next('/')
  }
  // e/o IE middleware

  // validate section url
  if (to.name === 'section') {
    const currentSlug = to.params.section
    const currentSectionIdx = store.getters.getSectionIdxBySlug(currentSlug)

    if (currentSectionIdx !== -1) {
      const currentSection = store.state.sections[currentSectionIdx]
      document.title = `Królewskie - ${currentSection.navTitle}`
      addMetaDescription(currentSection.metaDescription)

      store.commit('updateInitialSlide', currentSectionIdx + 1)
    } else {
      next('/404/')
    }
  }
  // e/o validate section url

  // add meta title
  if (to.meta.title) document.title = to.meta.title
  // add meta-description
  if (to.meta.description) addMetaDescription(to.meta.description)

  next()
})

export default router
